<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router';

interface Props {
	title?: string;
	hasLogo?: boolean;
	hasClose?: boolean;
	closeTo?: RouteLocationRaw;
}

const props = withDefaults(defineProps<Props>(), {
	hasClose: true,
});

const emit = defineEmits<{
	(event: 'update:visible', value: boolean): void;
}>();
</script>

<template>
	<div class="dialog__header" :class="{ 'dialog__header--has-logo': props.hasLogo }">
		<div class="dialog__logo" v-if="props.hasLogo">
			<HmLogo />
		</div>
		<h2 class="dialog__title" v-if="props.title">
			<span>{{ props.title }}</span>
		</h2>
		<template v-if="props.hasClose">
			<NuxtLink :to="props.closeTo" class="dialog__close" v-if="props.closeTo">
				<HmIcon name="x" />
				<span class="aria:sr">Close</span>
			</NuxtLink>
			<button
				type="button"
				class="dialog__close"
				v-else
				@click="emit('update:visible', false)"
			>
				<HmIcon name="x" />
				<span class="aria:sr">Close</span>
			</button>
		</template>
	</div>
</template>
